import app from "@/main";
import {evrakGonder} from "../../../evrak_gonder/EvrakGonder"
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {ITask} from "../GorevYoneticisiTypes";
import {TaskDurum} from "../../../enum/TaskDurum";

export class EvrakGonderTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            let dosya = await app.$uyap.DosyaBul().run(task);
            task.dosya_id = dosya.dosyaId;
            task.birim_adi = dosya.birimAdi;
            let evrakRes = await evrakGonder({
                dosyaId: task.dosya_id,
                birimAdi: task.birim_adi,
                evraklar: task.data,
                dosyaNo: dosya.dosyaNo,
                birimId: dosya.birimId
            });
            task.status = TaskDurum.BITTI_BASARILI;
            task.response = {
                dosyaEsasNo: task.dosya_esas_no,
                birimAdi: task.birim_adi,
                birimId: dosya.birimId,
                message: evrakRes?.message,
                isEmriNo: evrakRes?.value
            };
            return task;
        } catch (e) {
            console.log("task catch", e);
            task.status = TaskDurum.BITTI_HATALI;
            task.description = e.message;
            task.response = { evrakResult: e };
            throw new Error(e.message);
        }
    }
}
